import type { AllCompaniesNames } from '../../types/general';
import { allCompaniesFlows } from '../general/allCompaniesFlows';

/* Please refrain from using the following constant within any of the Onboarding views to avoid the dependency cycle */
export const companiesURLParameters = Object.keys(allCompaniesFlows).reduce(
  (companies, company) => ({ ...companies, [company]: company }),
  {},
) as Record<AllCompaniesNames, string>;
